import React, { useEffect, useState } from "react";
import useUserStore from "../../../stores/store";
import {
  getFormatedMembershipInfo,
  getMembershipInfo,
  isMembershipApplicable,
} from "../../../services/loyalty-membership-service";
import { CharLimit as charLimit } from "../../../constant/constants";
import { Image, Input } from "antd";

const LoyaltyMembership = ({ order, loyaltyMembershipInfo, setLoyaltyMembershipInfo, updateDiscountTypes }) => {
  const { user, loyaltyProgramSettings, restaurantId } = useUserStore();
  const [loading, setLoading] = useState(false);
  const [isApplicableMembership, setIsApplicableMembership] = useState(false);
  const [hasMembership, setHasMembership] = useState(false);
  const [memberName, setMemberName] = useState('');
  const [hasMemberName, setHasMemberName] = useState(false);

  const handleName = (e) => {
    const value = e.target.value;

    if (value.length > charLimit.Name) return;

    setLoyaltyMembershipInfo((prev) => ({
      ...prev,
      name: value,
    }));
  };

  const handleMembershipButton = (isAdd) => {
    setLoyaltyMembershipInfo((prev) => ({
      ...prev,
      shouldAddMembership: isAdd,
    }));
  };
  /**
   * This method should called when all the below caces will be fulfilled
   * Case1: Loyalty Program is active
   * Case2: The intended user is a customer
   *
   */
  const fetchMembershipInfo = async () => {
    const params = {
      restaurantId,
      userId: order.userId
    }
    setLoading(true);
    const result = await getMembershipInfo(params, user.token.token);

    if (result.hasMembership) {
      const tmpInfo = getFormatedMembershipInfo(result.record, order, loyaltyProgramSettings);
      setLoyaltyMembershipInfo(tmpInfo);
      setHasMembership(result.hasMembership);
      setMemberName(result.record.name);
      updateDiscountTypes(tmpInfo.loyaltyDiscountInfo.discountTypes);
    }

    setLoading(false);
  };

  useEffect(() => {
    setMemberName(order?.customerName || '');
    setHasMemberName(order?.customerName ? true : false )
    setHasMembership(false);
  }, [order]);

  useEffect(() => {
    console.log("*************************LoyaltyProgram***********************");
    setIsApplicableMembership(false);
    
    if (!loyaltyProgramSettings.isActive) {
      return;
    }

    if (isMembershipApplicable(order, user)) {
      setIsApplicableMembership(true);
      fetchMembershipInfo();
    }
  }, [order, loyaltyProgramSettings, user]);
  
  if (!loyaltyProgramSettings.isActive) {
    return "";
  }

  return (
    <div className="flex justify-between items-center mt-1 mb-1">
      <div>{`+${order.number}`}</div>
      {isApplicableMembership && (
        <div className="w-[200px]">
          {loyaltyMembershipInfo.shouldAddMembership ? (
            <Input value={loyaltyMembershipInfo.name} onChange={handleName} placeholder="Name" readOnly={hasMemberName}/>
          ) : (
            <span className="break-all line-clamp-1">{memberName}</span>
          )}
        </div>
      )}
      <div className="flex items-center gap-4">
        {!isApplicableMembership && <span className="text-red-600">Membership not applicable</span>}
        {isApplicableMembership &&  (
          <>
          {hasMembership && 
          <span>Points <span className="font-ubold">{loyaltyMembershipInfo.availablePoints.toFixed(2)}</span></span>
          }
          {!hasMembership && !loading &&
          <> 
            <div>Member</div>
            {!loyaltyMembershipInfo.shouldAddMembership && (
              <div>
                <button className={`mt-1`} onClick={() => handleMembershipButton(true)}>
                  <Image src="/images/icons/add_one.svg" preview={false} width={25} height={25}/>
                </button>
              </div>
            )}
            {loyaltyMembershipInfo.shouldAddMembership && (
              <div>
                <button className={`mt-1`} onClick={() => handleMembershipButton(false)}>
                  <Image src="/images/icons/remove_one.svg" preview={false}  width={25} height={25}/>
                </button>
              </div>
            )}
          </>
          }
          </>
        )}
      </div>
    </div>
  );
};

export default LoyaltyMembership;
